<template>
    <div>

        <div class="fixed-bg-overlay"></div>
        <div class="bg-blur" :style="{backgroundImage: 'url(' + require('@/assets/img/base/bg-blur.jpg') + ')'}"></div>
        <v-container>
            <v-layout wrap justify-center align-start v-scroll="onScroll">
                <v-flex xs12>
                    <w-main-title title="Promociones" :breadcrumbs="breadcrumbs"></w-main-title>
                </v-flex>
                <v-flex xs12>
                    <special-sales-carousel></special-sales-carousel>
                </v-flex>
                <v-flex xs12 >
                    <v-layout wrap align-center justify-start mt-3>
                        <v-flex xs12 sm6 lg8 text-xs-start>
                            <h1 class="title">Promociones activas</h1>
                        </v-flex>
                        <v-flex xs12 sm6 lg4>
                            <v-text-field
                                    class="ma-2"
                                    hide-details
                                    height="50"
                                    append-icon="search"
                                    outlined
                                    v-model="term"
                                    label="Búsqueda de promociones"
                                    placeholder="Escribe un servicio"
                                    clearable
                                    @keyup.enter="search"
                                    @click:clear="clearSearch"
                                    @click:append="search"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-divider></v-divider>

                    <v-layout wrap justify-start align-center fill-height >

                        <v-flex v-if="loading" xs12 pa-4 text-center>
                            <v-progress-circular indeterminate width="1" color="primary"></v-progress-circular>
                        </v-flex>

                        <v-flex v-if="specialSales.length === 0 && !loading" xs12 pa-4 text-center>
                            <h1 class="title font-weight-light">No hay promociones activas :(</h1>
                        </v-flex>
                        <v-flex xs12 md4 xl3 pa-1 v-show="!loading"  v-for="(specialSale, i) in specialSales" :key="i">
                            <special-sale :sale="specialSale"></special-sale>
                        </v-flex>

                        <v-flex xs12 md4 xl3 text-center pa-1 v-if="nextLink" class="next-link">
                            <div v-if="!loadingMore">
                                <v-avatar color="accent">
                                    <v-icon @click="more" color="white">fas fa-plus</v-icon>
                                </v-avatar>
                                <h1 class="title font-weight-light mt-2">Cargar mas</h1>
                            </div>

                            <v-progress-circular v-if="loadingMore" indeterminate width="1" color="primary"></v-progress-circular>


                        </v-flex>

                    </v-layout>

                </v-flex>
            </v-layout>
        </v-container>
    </div>

</template>

<script>

    import WMainTitle from '@/components/common/WMainTitle'
    import SpecialSalesCarousel from '@/components/special-sales/SpecialSalesCarousel'
    import SpecialSale from '@/components/providers/SpecialSale'

    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapMutations} from 'vuex'

    export default{
        components: {
            WMainTitle,
            SpecialSalesCarousel,
            SpecialSale
        },
        mounted(){
          this.search()
        },
        data(){
            return {
                term: '',
                loading: false,
                loadingMore: false,
                specialSales: [],
                nextLink: null,
                breadcrumbs: [
                    {
                        text: 'Inicio',
                        disabled: false,
                        to: '/'
                    },
                    {
                        text: 'Promociones',
                        disabled: true,
                        href: ''
                    },
                ]
            }
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            onScroll(){},
            async more(){
                var vm = this
                vm.loadingMore = true
                var endpoint = vm.nextLink
                const response = await ApiUtils.makeGet(endpoint)
                vm.loadingMore = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando buscar promociones')
                    return
                }

                const json = await response.json()
                vm.specialSales =vm.specialSales.concat(json.result.special_sales.data)
                vm.nextLink = json.result.special_sales.next_page_url
            },
            async search(){

                var vm = this
                vm.loading = true
                var endpoint = `public/special_sales?per_page=7&service=${vm.term}`
                const response = await ApiUtils.makeGet(endpoint)
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error intentando buscar promociones')
                    vm.nextLink = null
                    return
                }

                const json = await response.json()
                vm.specialSales = json.result.special_sales.data
                vm.nextLink = json.result.special_sales.next_page_url

            },
            clearSearch(){
                this.term = ''
                this.search()
            }
        }
    }
</script>

<style scoped>
    .next-link{
        min-height: 200px;
        padding-top: 40px !important;
    }
</style>
